import { useState } from "react";
import { Shield } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import type { UserWithProfile } from "@/pages/Users";
import { UserForm } from "./edit-user/user-form";
import { DialogActions } from "./edit-user/dialog-footer";
import { useUserUpdate } from "./edit-user/use-user-update";
import type { UserFormData } from "./edit-user/types";

interface EditUserDialogProps {
  user: UserWithProfile;
  onUserUpdated: () => Promise<void>;
}

export function EditUserDialog({ user, onUserUpdated }: EditUserDialogProps) {
  const [isOpen, setIsOpen] = useState(false);
  const [formData, setFormData] = useState<UserFormData>({
    firstName: user.profiles?.first_name || "",
    lastName: user.profiles?.last_name || "",
    email: user.profiles?.email || "",
    role: user.user_roles[0]?.role ?? "user"
  });
  
  const { isLoading, updateUser } = useUserUpdate(user, onUserUpdated);

  const handleFieldChange = (field: string, value: string) => {
    console.log("Field change:", field, value);
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleUpdateUser = async () => {
    console.log("Updating user with data:", formData);
    const success = await updateUser(formData);
    if (success) {
      setIsOpen(false);
    }
  };

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogTrigger asChild>
        <Button variant="ghost" size="sm">
          <Shield className="h-4 w-4" />
        </Button>
      </DialogTrigger>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>Modifier l'utilisateur</DialogTitle>
          <DialogDescription>
            Modifiez les informations de l'utilisateur
          </DialogDescription>
        </DialogHeader>

        <UserForm
          user={user}
          formData={formData}
          isLoading={isLoading}
          onFieldChange={handleFieldChange}
        />

        <DialogActions
          isLoading={isLoading}
          onCancel={() => setIsOpen(false)}
          onSave={handleUpdateUser}
        />
      </DialogContent>
    </Dialog>
  );
}